import { render, staticRenderFns } from "./ExternalBrokerEdit.vue?vue&type=template&id=33640e75"
import script from "./ExternalBrokerEdit.vue?vue&type=script&lang=js"
export * from "./ExternalBrokerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports